var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-overlay',{attrs:{"show":_vm.redirect,"rounded":"sm"}},[_c('b-button',{attrs:{"variant":"dark"},on:{"click":_vm.loginSubmit}},[_vm._v("\n      "+_vm._s(_vm.$t("START_IDENTIFICATION"))+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }